












import { Component } from 'nuxt-property-decorator'
import ExperienceBreadcrumb from '~/components/experience/experience-base/experience-breadcrumb'

@Component
export default class SubverticalBreadcrumb extends ExperienceBreadcrumb {
  get breadcrumbList() {
    const list: any = this.getBreadcrumb()
    const length = list.length
    const last = list[length - 1]
    list.splice(length - 1, 1, { id: last.id, name: last.name })
    return list
  }
}
